// extracted by mini-css-extract-plugin
export default {"loginPage":"login_loginPage__m5e5B","loginContainer":"login_loginContainer__Py8Q9","logo":"login_logo__8BiLI","logoutReason":"login_logoutReason__viQJe"};